/* eslint-disable max-len */
/* eslint-disable object-property-newline */
import React from 'react';
import { Config, Match } from '@leverege/plugin';
import { GlobalState, UI } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { ValuesCache } from '@leverege/value-cache';
import { RelationshipUtil } from '@leverege/ui-attributes';
import { GroupDelegate, ItemDelegate } from '@leverege/molten-core';
import { LinkAction } from "../routes/index.js";
import RemoveAction from "./actions/RemoveAction.js";
import DeleteAction from "./actions/DeleteAction.js";
import CreateAction from "./actions/CreateAction.js";
import BulkCreateAction from "./actions/BulkCreateAction.js";
import BulkUpdateAction from "./actions/BulkUpdateAction.js";
import UpdateAction from "./actions/UpdateAction.js";
import DetailsAction from "./actions/DetailsAction.js";
import Util from "./Util.js";
import RelationshipBreadcrumb from "./view/RelationshipBreadcrumbs.js";
import ArchitectLinkAction from "./actions/ArchitectLinkAction.js";
const {
  t,
  tf
} = I18N.ns('molten.imagine.BlueprintRouteCreator');
const groupActionsCache = new ValuesCache();
function processRelationship(molten, relationship, options) {
  const {
    attribute,
    parentRelationship: pRel,
    blueprint,
    path
  } = relationship;
  const grpClient = attribute == null ? options.rootClient : Config.get('BlueprintRoutes', `${attribute.blueprint.type}.ItemScreen/client`, 'ItemScreen');
  const hasItemRoute = attribute ? !attribute.hasTag('itemScreen:none') : true;
  // XXXtoMany relationships always have link, XXXtoOne relationships need link hidden if no item screen
  const hasLink = attribute ? !attribute.hasTag('itemScreen:none') || relationship.isOneToMany || relationship.isManyToMany : true;
  const isRoot = blueprint.hasTag('is:root');
  if (attribute == null && !isRoot) {
    return;
  }
  createInfo(molten, relationship, options);
  if (relationship.isGroup) {
    const grpId = `blueprint.${path}.GroupScreen`;
    const matches = attribute == null ? {
      client: grpClient
    } : {
      client: grpClient,
      path: pRel.path,
      objectType: attribute.blueprint.type
    };
    const matchContext = {
      path: relationship.path,
      objectType: relationship.objectType
    };
    const defaultSort = getSearchOptions('sort', 'default', blueprint, matchContext);
    const defaultFilter = getSearchOptions('filter', 'default', blueprint, matchContext);
    const baseSort = getSearchOptions('sort', 'base', blueprint, matchContext);
    const baseFilter = getSearchOptions('filter', 'base', blueprint, matchContext);

    // Add a Route to a group. Either a root like /dealer or a 
    // group relationship like /dealer/:buildingId/cars
    molten.addPlugin('Route', {
      id: `${grpId}:breadcrumbs`,
      matches: {
        client: 'Breadcrumbs'
      },
      exact: true,
      path: relationship.urlPath,
      render: ({
        match,
        ...rest
      }) => {
        const rel = relationship.createResolved(match);
        return /*#__PURE__*/React.createElement(RelationshipBreadcrumb, {
          match,
          ...rest,
          relationship: rel
        });
      }
    });
    molten.addPlugin('Route', {
      id: grpId,
      matches,
      exact: true,
      path: relationship.urlPath,
      default: isPreferredRoute(attribute),
      render: ({
        match,
        ...rest
      }) => {
        const rel = relationship.createResolved(match);
        let delegate;
        if (groupActionsCache.isSame(rel.path, match.url)) {
          delegate = groupActionsCache.value(rel.path);
        } else {
          delegate = groupActionsCache.set(rel.path, new GroupDelegate({
            match,
            relationship: rel,
            queryName: `${relationship.path}.search`
          }), match.url);
        }
        const props = {
          match,
          ...rest,
          relationship: rel,
          delegate,
          actions: delegate,
          defaultSort,
          defaultFilter,
          baseSort,
          baseFilter
        };
        return /*#__PURE__*/React.createElement(Config.get('BlueprintRoutes', `${grpId}/component`, options.groupScreen), props);
      }
    });
    molten.addPlugin('Action', {
      matches: [{
        // client : 'GroupScreen',
        use: ['contextMenu', 'mobileActionBar'],
        path: relationship.path,
        objectType: relationship?.blueprint?.type
      }, {
        client: ['GoogleMapsRolloverSelectionPointer', 'MapBoxRolloverSelectionPointer', 'ListDataViewer'],
        use: ['contextMenu', 'mobileActionBar']
      }],
      ...RemoveAction.create(relationship)
    });
    molten.addPlugin('Action', {
      matches: [{
        // client : 'GroupScreen',
        use: ['contextMenu', 'mobileActionBar'],
        path: relationship.path,
        objectType: relationship?.blueprint?.type
      }, {
        client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
        use: ['contextMenu', 'mobileActionBar']
      }],
      ...DeleteAction.create(relationship)
    });
    molten.addPlugin('Action', {
      matches: {
        client: ['GroupScreen', 'TableDataViewer'],
        use: ['contextMenu', 'mobileActionBar', 'noData'],
        path: relationship.path,
        objectType: relationship?.blueprint?.type
      },
      ...CreateAction.create(relationship)
    });
    if (blueprint.hasTag('bulkCreate:true')) {
      molten.addPlugin('Action', {
        matches: {
          client: 'GroupScreen',
          use: ['contextMenu'],
          path: relationship.path,
          objectType: relationship?.blueprint?.type
        },
        ...BulkCreateAction.create(relationship)
      });
    }
    if (blueprint.hasTag('bulkUpdate:true')) {
      molten.addPlugin('Action', {
        matches: {
          client: 'GroupScreen',
          use: ['contextMenu'],
          path: relationship.path,
          objectType: relationship?.blueprint?.type
        },
        ...BulkUpdateAction.create(relationship)
      });
    }
    molten.addPlugin('Action', {
      matches: [{
        // client : [ null, 'GroupScreen' ],
        use: ['contextMenu', 'mobileActionBar'],
        path: relationship.path,
        objectType: relationship?.blueprint?.type
      }, {
        client: ['GoogleMapsRolloverSelectionPointer', 'MapBoxRolloverSelectionPointer', 'ListDataViewer'],
        use: ['contextMenu', 'mobileActionBar']
      }],
      ...UpdateAction.create(relationship)
    });
    // molten.addPlugin( 'Action', {
    //   matches : {
    //     client : 'GroupScreen',
    //     use : [ 'contextMenu', 'mobileActionBar' ],
    //     path : relationship.path,
    //     objectType : relationship?.blueprint?.type
    //   },
    //   ...BulkUpdateAction.create( relationship ),
    // } )

    molten.addPlugin('Action', {
      matches: [{
        use: ['itemBar', 'itemBarMobile'],
        path: relationship.path,
        objectType: relationship.objectType
      }, {
        client: ['GoogleMapsRolloverSelectionPointer', 'MapBoxRolloverSelectionPointer'],
        use: ['itemBar', 'mobileActionBar']
      }],
      ...DetailsAction.create(relationship)
    });
    molten.addPlugin('Action', {
      matches: [{
        client: ['ItemInfoScreen'],
        use: ['contextMenu', 'mobileActionBar'],
        path: relationship.path,
        objectType: relationship?.blueprint?.type
      }],
      ...ArchitectLinkAction.create(relationship)
    });
  }

  // Add the action plugin to take us to this page.
  const actionId = `blueprint.link.${path}.GroupScreen`;
  const actionName = attribute == null ? blueprint.namePlural : attribute.name || attribute.path;
  const sort = (attribute || blueprint).getTagStartingWith('navSort:', true);
  const sectionName = (attribute || blueprint).getTagStartingWith('navSectionName:', true);
  const rootGroup = blueprint.getTagStartingWith(attribute == null ? 'rootNavGroup:' : 'navGroup:', true)?.split(',').map(s => s.trim());
  const rootGroupIcons = blueprint.getTagStartingWith(attribute == null ? 'rootNavGroupIcons:' : 'navGroupIcons:', true)?.split(',').map(s => s.trim());
  const excludeFrom = blueprint.getTagsStartingWith('excludeFrom:', true);
  const attrExcludeFrom = attribute ? attribute.getTagsStartingWith('excludeFrom:', true) : [];
  if (hasLink) {
    molten.addPlugin('Action', LinkAction.create({
      id: actionId,
      layout: Config.get(actionId, 'layout', {
        group: rootGroup,
        groupIcons: rootGroupIcons,
        sort: sort || `rel.${actionName}`,
        sectionName
      }),
      matches: {
        use: 'navBar',
        client: grpClient,
        path: pRel == null ? null : pRel.path
      },
      handles: cxt => {
        const aPersona = UI.get(GlobalState.get()).activePersona?.name;
        if (Util.shouldExclude(aPersona, attribute, excludeFrom, attrExcludeFrom)) {
          return false;
        }
        return true;
      },
      name: actionName,
      icon: getNavIcon(blueprint, attribute),
      path: relationship.urlPath
    }));
  }

  // Add the Item Route. If this is 1-to-1, the path will not include the :typeId
  if (hasItemRoute) {
    const itemId = `blueprint.${path}.ItemScreen`;
    let clientMatch = {
      client: options.rootClient
    };
    const embed = attribute?.hasTag('itemScreen:embed') || false;
    if (embed) {
      clientMatch = {
        path: relationship.parentRelationship.path
      };
    }
    molten.addPlugin('Route', {
      id: `${itemId}:breadcrumbs`,
      matches: {
        client: 'Breadcrumbs'
      },
      exact: true,
      path: attribute?.isOneToOne() ? `${relationship.urlPath}` : `${relationship.urlPath}/:${RelationshipUtil.getValidIdKey(blueprint.type)}`,
      render: ({
        match,
        ...rest
      }) => {
        const rel = relationship.createItem(match);
        return /*#__PURE__*/React.createElement(RelationshipBreadcrumb, {
          match,
          ...rest,
          relationship: rel
        });
      }
    });
    molten.addPlugin('Route', {
      id: itemId,
      matches: clientMatch,
      exact: false,
      // HERE SMJ: resoruceId and path? 
      path: attribute?.isOneToOne() ? `${relationship.urlPath}` : `${relationship.urlPath}/:${RelationshipUtil.getValidIdKey(blueprint.type)}`,
      default: isPreferredRoute(attribute),
      render: ({
        match,
        ...rest
      }) => {
        const iRel = relationship.createItem(match);
        const delegate = new ItemDelegate({
          match,
          relationship: iRel,
          id: iRel.id
        });
        const props = {
          match,
          ...rest,
          relationship: iRel,
          resourceId: iRel.id,
          embed,
          objectType: attribute?.blueprint.type || blueprint.type,
          delegate,
          actions: delegate // TODO: Remove in future version
        };
        return /*#__PURE__*/React.createElement(Config.get('BlueprintRoutes', `${itemId}/component`, options.itemScreen), props);
      }
    });
  }
}
function createInfo(molten, relationship, options) {
  const {
    attribute,
    blueprint,
    path,
    objectType
  } = relationship;
  const infoId = `blueprint.${path}.InfoScreen`;
  const infoClient = Config.get('BlueprintRoutes', `${blueprint.type}.InfoScreen/client`, 'ItemScreen');
  const urlPath = attribute?.isOneToOne() ? `${relationship.urlPath}/info` : `${relationship.urlPath}/:${RelationshipUtil.getValidIdKey(blueprint.type)}/info`;
  const actionId = `blueprint.link.${path}.InfoScreen`;
  const excludeFrom = blueprint.getTagsStartingWith('excludeFrom:', true);
  const attrExcludeFrom = attribute ? attribute.getTagsStartingWith('excludeFrom:', true) : [];
  const navSortOverview = blueprint.getTagStartingWith('navSortOverview:', true) || 'aaa';
  const sectionName = blueprint.getString('overviewSectionName');
  molten.addPlugin('Action', LinkAction.create({
    id: actionId,
    layout: Config.get(actionId, 'layout', {
      sort: navSortOverview,
      sectionName
    }),
    matches: {
      use: 'navBar',
      client: infoClient,
      objectType,
      path: relationship.path
    },
    handles: cxt => {
      const aPersona = UI.get(GlobalState.get()).activePersona?.name;
      if (Util.shouldExclude(aPersona, attribute, excludeFrom, attrExcludeFrom)) {
        return false;
      }
      return true;
    },
    name: tf('overview'),
    icon: getNavIcon(blueprint, attribute),
    path: urlPath
  }));
  molten.addPlugin('Route', {
    id: `${infoId}:breadcrumbs`,
    matches: {
      client: 'Breadcrumbs'
    },
    exact: true,
    path: urlPath,
    render: ({
      match,
      ...rest
    }) => {
      const rel = relationship.createItem(match);
      const name = t('overview');
      const extraCrumbs = [{
        name,
        tooltip: name,
        url: urlPath
      }];
      return /*#__PURE__*/React.createElement(RelationshipBreadcrumb, {
        match,
        ...rest,
        extraCrumbs,
        relationship: rel
      });
    }
  });
  molten.addPlugin('Route', {
    id: infoId,
    matches: {
      client: infoClient,
      objectType,
      path
    },
    exact: true,
    path: urlPath,
    default: isOverviewPreferredRoute(blueprint),
    render: ({
      match,
      ...rest
    }) => {
      const iRel = relationship.createItem(match);
      const delegate = new ItemDelegate({
        match,
        relationship: iRel,
        id: iRel.id
      });
      const props = {
        match,
        ...rest,
        relationship: iRel,
        resourceId: iRel.id,
        objectType: attribute?.blueprint.type || blueprint.type,
        delegate,
        // TODO ITEM ACTIONS
        actions: delegate // TODO: Remove in future version
      };
      const parentIsItem = delegate?.parent() instanceof ItemDelegate;
      const parentExists = delegate?.parent()?.getItem?.(GlobalState.get());
      const childIsItem = delegate instanceof ItemDelegate;
      const childExists = delegate?.getItem?.(GlobalState.get());
      if (parentIsItem && childIsItem && parentExists && !childExists) {
        return /*#__PURE__*/React.createElement(Config.get('BlueprintRoutes', `${infoId}/component`, options.missingRelScreen), props);
      }
      return /*#__PURE__*/React.createElement(Config.get('BlueprintRoutes', `${infoId}/component`, options.infoScreen), props);
    }
  });
}
function isPreferredRoute(attr) {
  if (attr == null) {
    return false;
  }
  if (attr.hasTag('is:preferredView')) {
    return true;
  }
  const attrs = attr.blueprint.attributes.filter(a => a.isRelationship());
  if (attr === attrs[0]) {
    for (let n = 1; n < attrs.length; n++) {
      if (attrs[n].hasTag('is:preferredView')) {
        return false;
      }
    }
    return !isOverviewPreferredRoute(attr.blueprint);
  }
  return false;
}
function isOverviewPreferredRoute(blueprint) {
  let hasPreferrredRoute = false;
  const attrs = blueprint.attributes.filter(a => a.isRelationship());
  for (let n = 1; n < attrs.length; n++) {
    if (attrs[n].hasTag('is:preferredView')) {
      hasPreferrredRoute = true;
    }
  }
  return blueprint.hasTag('overviewPreferred') || !hasPreferrredRoute;
}
function getSearchOptions(type, subtype, blueprint, matchContext) {
  const defaults = blueprint.metadata?.searchOptions?.[type]?.[subtype];
  let def;
  if (defaults) {
    const match = defaults.find(value => {
      return Match.isMatch(matchContext, value.matches);
    });
    def = match?.[type];
  }
  return def;
}
function getNavIcon(blueprint, attribute) {
  if (attribute == null) {
    return blueprint.getIcon('navIcon');
  }
  return attribute.getIcon('navIcon') || blueprint.getIcon('navIcon');
}
export default {
  id: 'molten.BlueprintRouteCreator',
  type: 'molten.BlueprintRouteCreator',
  processRelationship
};